import React, { Fragment } from 'react';
import {compose} from 'redux';
import {translate} from 'react-i18next';
import {Card, Col, Form, Input, Modal, Row} from 'antd';
import _ from 'lodash';
import {connect} from "react-redux";
import { ID_MAX_LEN } from '../../../constants/generals';
import { GUTTER_MD, MARGIN_MD, SPAN_FULL, SPAN_HALF, SPAN_ONE_THIRD, SPAN_TWO_THIRDS } from '../../../styles/constants';
import { DataLanguageConsumer } from '../../../contexts/DataLanguage';
import { isIDValidWithHelp } from '../../../utils/artefactValidators';
import PerfInput from '../../../components/perf-input';
import AnnotationsForm from '../../../components/annotations-form';
import MultilanguageZoomableTextArea from "../../../components/multilanguage-zoomable-textarea";
import MultilanguageInput from "../../../components/multilanguage-input";
import { HIERARCHY_FORM_MODE_CREATE, HIERARCHY_FORM_MODE_READ } from './utils';
// import { HIERARCHY_LEVEL_BASED, HIERARCHY_VALUE_BASED } from '../../../utils/sdmxJson';


const mapStateToProps = state => ({
  appLanguage: state.app.language
});

const mapPropsToFields = ({hierarchy}) => ({
  id: Form.createFormField({value: hierarchy ? hierarchy.id : null}),
  name: Form.createFormField({value: hierarchy ? hierarchy.name : null}),
  description: Form.createFormField({value: hierarchy ? hierarchy.description : null}),
  // type: Form.createFormField({value: hierarchy ? hierarchy.type : HIERARCHY_VALUE_BASED}),
});

const onChange = (onChange, hierarchy, fields) => {
  const customizer = (_, src, key) => {    
    if (key === "annotations")
      return src;
    else {
      return undefined
    }
  };

  const newHierarchy = _.cloneDeep(hierarchy);

  onChange(_.mergeWith(newHierarchy, fields, customizer));
}


const onFieldsChange = (props, fields) => {
  
  const newFields = _.mapValues(fields, ({value}) => value);
  if (newFields.id && newFields.id.length > ID_MAX_LEN) {
    Modal.warning({
      title: props.t('commons.alerts.fieldTooLong.title'),
      content: props.t('commons.alerts.fieldTooLong.content', {maxLen: ID_MAX_LEN})
    });
    onChange(props.onChange,props.hierarchy, props.hierarchy);
  } 
  // else if (newFields.type && newFields.type === HIERARCHY_LEVEL_BASED) {
  //   Modal.warning({
  //     title: props.t('components.hierarchicalCodelistDetailItems.hierarchyForm.notSupported.title'),
  //     content: props.t('components.hierarchicalCodelistDetailItems.hierarchyForm.notSupported.content')
  //   });
  //   onChange(props.onChange,props.hierarchy, props.hierarchy);
  // }
  else {
    onChange(props.onChange,props.hierarchy, newFields);
  }
};

const formItemLayout = {
  labelCol: {span: SPAN_ONE_THIRD},
  wrapperCol: {span: SPAN_TWO_THIRDS}
};

const rowStyle = {
  marginBottom: MARGIN_MD,
  marginLeft: MARGIN_MD,
  marginRight: MARGIN_MD
};


const HierarchyForm = ({
                           t,
                           form,
                           mode = HIERARCHY_FORM_MODE_CREATE,
                           hierarchy
                         }) => {

  return (
    <DataLanguageConsumer>
      {dataLanguage => {
        return (
          <Fragment>            
            <Form >  
              <Row gutter={GUTTER_MD} style={rowStyle}>
                <Col span={SPAN_HALF}>
                  <Form.Item
                    className={mode === HIERARCHY_FORM_MODE_CREATE ? 'form-item-required' : null}
                    label={t('scenes.metaManager.hierarchicalCodelists.detail.hierarchy.id.label')}
                    validateStatus={hierarchy && isIDValidWithHelp(t, hierarchy.id).help ? "warning" : null}
                    help={hierarchy && isIDValidWithHelp(t, hierarchy.id).help}
                    {...formItemLayout}
                  >
                    {form.getFieldDecorator('id', {
                      getValueFromEvent: e => (e || "").toUpperCase()
                    })(
                      <PerfInput
                        Component={Input}
                        title={form.getFieldValue('id')}
                        disabled={mode !== HIERARCHY_FORM_MODE_CREATE}
                        style={{textTransform: "uppercase"}}
                      />
                    )}
                  </Form.Item>
                </Col>
                <Col span={SPAN_HALF}>
                  <Form.Item
                    // className={mode === HIERARCHY_FORM_MODE_CREATE ? 'form-item-required' : null}
                    label={t('scenes.metaManager.hierarchicalCodelists.detail.hierarchy.type.label')}
                    {...formItemLayout}
                  >
                    <Input
                      value={t("scenes.metaManager.hierarchicalCodelists.detail.hierarchy.type.values.valueBased")} 
                      // readOnly  
                      disabled={true}               
                    />
                    {/* {form.getFieldDecorator('type')(
                      <Select 
                        disabled={mode !== HIERARCHY_FORM_MODE_CREATE}
                      >
                        <Select.Option value={HIERARCHY_VALUE_BASED}>
                          {t("scenes.metaManager.hierarchicalCodelists.detail.hierarchy.type.values.valueBased")}
                        </Select.Option>
                        <Select.Option value={HIERARCHY_LEVEL_BASED}>
                          {t("scenes.metaManager.hierarchicalCodelists.detail.hierarchy.type.values.levelBased")}
                        </Select.Option>
                      </Select>
                    )} */}
                  </Form.Item>
                </Col>
              </Row>
              <Card type="inner" bodyStyle={{paddingLeft: 19, paddingRight: 22}}>
                <Row type="flex" gutter={GUTTER_MD} style={{marginBottom: MARGIN_MD}}>
                  <Col span={SPAN_FULL}>
                    <Form.Item
                      className={mode !== HIERARCHY_FORM_MODE_READ ? 'form-item-required' : null}
                      label={t('scenes.metaManager.hierarchicalCodelists.detail.hierarchy.name.label')}
                      labelCol={{span: 4}}
                      wrapperCol={{span: 20}}
                    >
                      {form.getFieldDecorator('name')(
                        <PerfInput
                          Component={MultilanguageInput}
                          title={form.getFieldValue('name')}
                          disabled={mode === HIERARCHY_FORM_MODE_READ}/>
                      )}
                    </Form.Item> 
                  </Col>             
                </Row>
                <Row type="flex" gutter={GUTTER_MD}>
                  <Col span={SPAN_FULL}>
                    <Form.Item
                        label={t('scenes.metaManager.hierarchicalCodelists.detail.hierarchy.description.label')}
                        labelCol={{span: 4}}
                        wrapperCol={{span: 20}}
                      >
                        {form.getFieldDecorator('description')(
                          <PerfInput
                            Component={MultilanguageZoomableTextArea}
                            disabled={mode === HIERARCHY_FORM_MODE_READ}
                          />
                        )}
                    </Form.Item>
                  </Col>
                </Row>
              </Card>
            </Form>
            <AnnotationsForm
              annotations={hierarchy ? hierarchy.annotations : null}
              onChange={onChange}
              disabled={mode === HIERARCHY_FORM_MODE_READ}
            />
        </Fragment>
        );
      }}
    </DataLanguageConsumer>
  )
};

export default compose(
  translate(),
  connect(mapStateToProps),
  Form.create({mapPropsToFields, onFieldsChange})
)(HierarchyForm);
